import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import EventListPageUI from './EventListPageUI.js'

class EventListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      eventLogList: null,
      details: false
    }
  }

  render() {
    return (
      <EventListPageUI
        context={this.props.context}
        account={this.state.account}
        eventLogList={this.state.eventLogList}
        onRefreshClick={this.onRefreshClick}
        details={this.state.details}
        onDetailsClick={() => {this.setState({details: !this.state.details})}}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getEventLogs(context)
  }

  getEventLogs(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/eventLogs`,
      cacheKey: CacheKeys.EventLogs(this.props.match.params.accountId),
      callback: this.getEventLogsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getEventLogsCallback = (response) => {
    this.setState({eventLogList : response.eventLogList})
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({account : response.account})
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.EventLogs(this.props.match.params.accountId))
    this.setState({eventLogList: null},
      this.getEventLogs(this.props.context)
    )
  }
}

export default withRouter(EventListPageSF)
